import React from 'react';
import styled from 'styled-components';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import RadarChart from '../RadarChart';
import icono from '../imgs/icons/edu_iconos_binoculars.svg';

export const ChartWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  width: 100%;
  position: relative;
  ${'' /* bug with polar lines on radar pdf print */}
  @media print {
    svg {
      g {
        line {
          opacity: 0;
        }
      }
    }
  }
`;

const VocationOnePreferencesGraphPage = ({ user, background, number }) => {
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>2.2. Mapa de preferencias</h2>
          <p className='justified'>
            El siguiente mapa te muestra cómo se expresan tus preferencias en
            relación al resto de las preferencias del modelo:
          </p>
          <ChartWrapper>
            <RadarChart user={user} />
          </ChartWrapper>

          <br />
          <br />

          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: -45, left: -25 }}>
              <img
                src={icono}
                alt='icono binoculares'
                style={{ width: 100, height: 'auto' }}
              />
            </div>
            <div className='edu-bubble-group bg-edu-red'>
              <p className='justified'>
                El mapa de preferencias te permite observar si tus preferencias
                se agrupan en un mismo sector (p.e., todas se relacionan con el
                trabajo con personas, o se inclinan hacia el área de la ciencia
                y mecánica). También puede ocurrir que tengas puntajes altos en
                áreas muy distintas (por ejemplo, atracción por Artes y
                Administración al mismo tiempo). Es normal que esto ocurra, y
                puede estar dando cuenta de mayor variedad de intereses.{' '}
                <strong>
                  ¡No te preocupes! hoy en día hay muchas carreras que combinan
                  disciplinas muy distintas.
                </strong>
              </p>
              <p className='justified'>
                También puede ocurrir que aún no tengas tanta claridad sobre tus
                intereses, o no tengas información suficiente, y por eso
                aparezcan intereses más diversos.{' '}
                <strong>
                  Conversar con personas de diversas carreras y acercarse al
                  mundo del trabajo te puede ayudar a identificar mejor las
                  actividades o contextos donde te gustaría trabajar más en un
                  futuro.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOnePreferencesGraphPage;
